module.exports = __webpack_public_path__ + "img/17bda45.png";